function getConfig(name, defaultValue = null) {
    // If inside a docker container, use window.ENV
    if (window.ENV !== undefined) {
        return window.ENV[name] || defaultValue;
    }

    return process.env[name] || defaultValue;
}

export function getBackendUrl() {
    return getConfig('REACT_APP_BACKEND_URL');
}

export function normalizeMediaUrl(url) {
    if (!url) return url;

    const rawUrl = String(url).trim();
    const backendUrl = getBackendUrl();

    const buildWindowBackendBase = (fallbackPort = "3100") => {
        if (typeof window === "undefined") return "";
        return `${window.location.protocol}//${window.location.hostname}:${fallbackPort}`;
    };

    const resolveBackendBase = () => {
        if (backendUrl) {
            try {
                const parsedBackend = new URL(backendUrl);
                const isLocalBackend = ["localhost", "127.0.0.1", "0.0.0.0"].includes(parsedBackend.hostname);

                if (!isLocalBackend) {
                    return `${parsedBackend.protocol}//${parsedBackend.host}`;
                }
            } catch (_err) {
                // fallback abaixo
            }
        }

        return buildWindowBackendBase("3100");
    };

    if (rawUrl.startsWith("/")) {
        const base = resolveBackendBase();
        return `${base.replace(/\/$/, "")}${rawUrl}`;
    }

    try {
        const parsed = new URL(rawUrl);
        const isLocalMediaHost = ["localhost", "127.0.0.1", "0.0.0.0"].includes(parsed.hostname);

        if (!isLocalMediaHost) {
            return rawUrl;
        }

        const targetBase = resolveBackendBase();
        const target = new URL(targetBase);

        parsed.protocol = target.protocol;
        parsed.hostname = target.hostname;
        parsed.port = target.port || parsed.port;

        return parsed.toString();
    } catch (_err) {
        return rawUrl;
    }
}

export function getHoursCloseTicketsAuto() {
    return getConfig('REACT_APP_HOURS_CLOSE_TICKETS_AUTO');
}

export function getFrontendPort() {
    return getConfig('SERVER_PORT');
}

export function getPrimaryColor() {
    return getConfig("REACT_APP_PRIMARY_COLOR");
}

export function getPrimaryDark() {
    return getConfig("REACT_APP_PRIMARY_DARK");
}

export function getNumberSupport() {
    return getConfig("REACT_APP_NUMBER_SUPPORT");
}